import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-taxa-crescimento',
    templateUrl: './taxa-crescimento.component.html',
    styleUrls: ['./taxa-crescimento.component.less']
})
export class TaxaCrescimentoComponent {
    @Input() taxaCrescimento: number = null;
    @Input() minFractionDigits = 2;
    @Input() maxFractionDigits = 2;
}
